import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageProvider';
export function Hero() {
  const {
    language,
    t
  } = useLanguage();
  return <section id="top" className="border-b border-ink/15 bg-paper paper-grain" data-id="element-32" data-mp="9ll9mylze0o1">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:grid-cols-[1.35fr_1fr] md:py-16" data-id="element-33" data-mp="4mi3fau9loeh">
        <motion.div key={`hero-${language}`} initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-34" data-mp="129qwbqwlhzqi">
          <p className="inline-flex items-center gap-2 bg-accent px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-paper" data-id="element-35" data-mp="sa9rfbp63pvl">
            {t.hero.badge}
          </p>
          <h2 className="mt-5 font-serif text-4xl font-black leading-[1.05] tracking-tight sm:text-6xl" data-id="element-36" data-mp="3d21sdxnwkknq">
            {t.hero.headline}
          </h2>
          <p className="mt-5 max-w-2xl font-serif text-xl italic leading-relaxed text-muted" data-id="element-37" data-mp="3814cxsua24px">
            {t.hero.ledeStart}
            <strong className="not-italic font-semibold text-ink" data-id="element-38" data-mp="3o7ls3r2jl6oy">{t.hero.ledeShop}</strong>
            {t.hero.ledeEnd}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-ink/15 pt-4 text-[12px] uppercase tracking-[0.14em] text-muted" data-id="element-39" data-mp="39b4h50y9lu2x">
            <span data-id="element-40" data-mp="3eb91x367hayy">{t.hero.metaPlace}</span>
            <span className="hidden h-3 w-px bg-ink/25 sm:block" data-id="element-41" data-mp="30hrjxmt646b1" />
            <span data-id="element-42" data-mp="358rdqj6zq89b">{t.hero.metaFile}</span>
            <span className="hidden h-3 w-px bg-ink/25 sm:block" data-id="element-43" data-mp="359sxrd5zi536" />
            <span className="text-accent" data-id="element-44" data-mp="2qk3lomwcsgo4">{t.hero.metaStatus}</span>
          </div>
        </motion.div>

        <motion.aside key={`aside-${language}`} initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.12,
        ease: 'easeOut'
      }} className="self-start border border-ink/20 bg-white/60 p-6" aria-label={t.hero.asideLabel} data-id="element-45" data-mp="2vieucuawwl4r">
          <h3 className="flex items-center gap-2 font-sans text-[12px] font-bold uppercase tracking-[0.18em] text-accent" data-id="element-46" data-mp="s2tdvmncibq9">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="n98bzjimsxls" />
            {t.hero.asideTitle}
          </h3>
          <ul className="mt-4 space-y-3 text-[15px] leading-relaxed" data-id="element-48" data-mp="dd5cklf5zd2j">
            {t.hero.asideLines.map(line => <li key={line} className="border-l-2 border-accent/60 pl-3 text-ink/85" data-id="element-49" data-mp="1b1fg54ulm8vr">
                {line}
              </li>)}
          </ul>
        </motion.aside>
      </div>
    </section>;
}